import { Inbox } from "lucide-react";

export function EmptyState() {
  return (
    <div className="grid h-full place-items-center text-center text-muted dark:text-muted-dark">
      <div>
        <Inbox className="mx-auto mb-3 h-8 w-8 text-dim" />
        <div className="text-sm font-medium">タスクはありません</div>
      </div>
    </div>
  );
}
